export const dispatchWithPromise = ( dispatch, action) => {
    return new Promise((resolve, reject) => {
      const result = dispatch(action);
      if (result?.error) {
        reject(result?.error);
      } else {
        resolve(result);
      }
    });
  };